import { Component, EventEmitter, Input, Output } from '@angular/core';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-send-list',
  templateUrl: './send-list.component.html',
  styleUrls: ['./send-list.component.scss']
})
export class SendListComponent {

  @Input() messages: any[] = [];
  @Input() listType: 'sent' | 'waiting' | 'trash' = 'sent';
  @Input() loading: boolean = false;

  @Output() showDetail = new EventEmitter<any>();
  @Output() resend = new EventEmitter<any>();
  @Output() moveToTrash = new EventEmitter<any>();
  @Output() restore = new EventEmitter<any>();
  @Output() deletePermanent = new EventEmitter<any>();

  selectedItems: Set<string> = new Set();
  allSelected: boolean = false;

  get emptyMessage(): string {
    switch (this.listType) {
      case 'sent': return 'Aucun message envoyé pour l\'instant.';
      case 'waiting': return 'Aucun message en attente.';
      case 'trash': return 'Aucun message dans la corbeille.';
    }
  }

  toggleSelectAll(): void {
    if (this.allSelected) {
      this.selectedItems.clear();
      this.allSelected = false;
    } else {
      this.messages.forEach(m => this.selectedItems.add(m.uuid));
      this.allSelected = true;
    }
  }

  toggleSelect(uuid: string): void {
    if (this.selectedItems.has(uuid)) {
      this.selectedItems.delete(uuid);
    } else {
      this.selectedItems.add(uuid);
    }
    this.allSelected = this.selectedItems.size === this.messages.length;
  }

  isSelected(uuid: string): boolean {
    return this.selectedItems.has(uuid);
  }

  get hasSelection(): boolean {
    return this.selectedItems.size > 0;
  }

  getPersonaliseLabel(send: any): string {
    const labels: Record<string, string> = {
      'PROPRIETAIRE': 'Bailleur(s)',
      'LOCATAIRE': 'Locataire(s)',
      'CLIENT': 'Client(s)',
      'PROSPECT': 'Prospect(s)'
    };
    if (labels[send?.personalise]) {
      return labels[send.personalise];
    }
    if (send?.personalise === 'DEFINIR') {
      return send?.type === 'MAIL' ? 'Mail(s) définir' : 'Numéro(s) définir';
    }
    return '';
  }

  truncateContent(str: string): string {
    if (!str) return '';
    const stripped = str.replace(/<[^>]*>/g, '');
    return stripped.length > 70 ? stripped.substring(0, 70) + ' ...' : stripped;
  }

  onShowDetail(send: any): void {
    this.showDetail.emit(send);
  }

  onResend(send: any): void {
    this.resend.emit(send);
  }

  onMoveToTrash(send: any): void {
    this.moveToTrash.emit(send);
  }

  onRestore(send: any): void {
    this.restore.emit(send);
  }

  onDeletePermanent(send: any): void {
    Swal.fire({
      title: 'Suppression définitive',
      text: 'Cette action est irréversible. Voulez-vous vraiment supprimer ce message ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Supprimer',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        this.deletePermanent.emit(send);
      }
    });
  }

  // Actions en lot
  batchMoveToTrash(): void {
    const selected = this.messages.filter(m => this.selectedItems.has(m.uuid));
    Swal.fire({
      title: 'Déplacer vers la corbeille',
      text: `Voulez-vous déplacer ${selected.length} message(s) vers la corbeille ?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Oui',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        selected.forEach(m => this.moveToTrash.emit(m));
        this.selectedItems.clear();
        this.allSelected = false;
      }
    });
  }

  batchDelete(): void {
    const selected = this.messages.filter(m => this.selectedItems.has(m.uuid));
    Swal.fire({
      title: 'Suppression définitive',
      text: `Voulez-vous supprimer définitivement ${selected.length} message(s) ? Cette action est irréversible.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Supprimer',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        selected.forEach(m => this.deletePermanent.emit(m));
        this.selectedItems.clear();
        this.allSelected = false;
      }
    });
  }

  batchRestore(): void {
    const selected = this.messages.filter(m => this.selectedItems.has(m.uuid));
    selected.forEach(m => this.restore.emit(m));
    this.selectedItems.clear();
    this.allSelected = false;
  }
}
